import {
  DELIVERY_COST,
  SECOND_DELIVERY_COST,
  FREE_SECOND_SHIPPING_MIN_AMOUNT,
  FREE_SHIPPING_MIN_AMOUNT,
} from '@config/constants';

interface DeliveryCosts {
  oldDeliveryCost: number;
  deliveryCost: number;
}
export function getDeliveryCosts(item: {
  orders: {
    deliveryCoupon: boolean;
    totalCost: number;
  }[];
  deliveryCost: number;
}): DeliveryCosts {
  const usedDeliveryCoupons = item.orders.filter(
    (order) => order.deliveryCoupon,
  ).length;
  const totalCost = item.orders[0].totalCost;
  const productsCost = totalCost - item.deliveryCost;
  const oldDeliveryCost =
    item.orders.length === 2
      ? usedDeliveryCoupons === 2
        ? DELIVERY_COST + SECOND_DELIVERY_COST
        : usedDeliveryCoupons === 1
        ? productsCost < FREE_SHIPPING_MIN_AMOUNT
          ? DELIVERY_COST + SECOND_DELIVERY_COST
          : productsCost < FREE_SECOND_SHIPPING_MIN_AMOUNT
          ? SECOND_DELIVERY_COST
          : null
        : null
      : item.orders.length === 1
      ? usedDeliveryCoupons === 1
        ? productsCost < FREE_SHIPPING_MIN_AMOUNT
          ? DELIVERY_COST
          : null
        : null
      : null;
  return {
    oldDeliveryCost,
    deliveryCost: item.deliveryCost,
  };
}
